import UniversalRegisterForm from '@/domains/auth/components/register/UniversalRegisterForm';

export default function RegisterPage() {
    return <UniversalRegisterForm />;
}